// extracted by mini-css-extract-plugin
export var productImage = "_vt-0";